<template>
  <div class="pt-4">
    <b-modal ref="previewModal" hide-footer size="sm">
      <h2 class="mt--5 pb-3">Terms & Conditions</h2>
      <div style="white-space:pre-wrap">{{ previewText }}</div>
    </b-modal>

    <b-sidebar
      backdrop
      lazy
      id="sidebar-1"
      title="Key Fields"
      bg-variant="white"
      v-model="showSideBar"
    >
      <div class="px-3 py-2">
        Click to copy the key field, and then paste in your template
        <hr />

        <div v-for="key in model.keyItems" v-bind:key="key.key" class="pb-3">
          <div class="d-flex">
            <a href="#" @click.prevent="copy(key.key)">
              <div
                v-b-tooltip.hover.right
                :title="key.value"
                v-html="'{{ ' + key.key + ' }}'"
              ></div>
            </a>
          </div>
        </div>
      </div>
    </b-sidebar>
    <div class="row">
      <div class="col">
        <h3>{{ title }}</h3>
        <div class="row">
          <div class="col-8">
            <p class="text-muted">
              {{ desc }}
              <a href="#" @click.prevent="showSideBar = true">key fields</a>.
            </p>
          </div>

          <div class="col-4 text-right mb-5">
            <b-button
              variant="primary"
              class="btn-outline-primary"
              @click="preview"
              :disabled="!model.template"
              ><i class="fa-solid fa-eye"></i> Preview</b-button
            >
          </div>
        </div>

        <b-textarea
          rules="required"
          class="form-control p-4"
          @input="$emit('templateUpdate', model.template)"
          v-model="model.template"
          rows="16"
        >
        </b-textarea>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "user-template",
  props: {
    template: null,
    keyItems: null,
    _name: null,
    title: { default: "Terms & Conditions", type: String },
    desc: {
      default:
        "Please adjust based on the practice's unique terms and conditions. This template accepts these",
      type: String,
    },
  },
  data() {
    return {
      model: { template: null, keyItems: null },
      previewText: null,
      showSideBar: false,
    };
  },
  mounted() {
    this.model.keyItems = this.keyItems;
  },
  watch: {
    template: {
      immediate: true,
      handler(val) {
        this.model.template = val;
      },
    },
  },

  methods: {
    copy(key) {
      let t = "{{" + key + "}}";

      navigator.clipboard.writeText(t).then(() => {
        this.$emitter.emit("success", { message: t + " copied to clipboard." });
        this.showSideBar = false;
      });
    },
    async preview() {
      let r = await this.$client.post("/api/usertemplate/preview", this.model);

      if (r.data.isSuccess) {
        this.previewText = r.data.value.previewText;
        this.$refs.previewModal.show();
      }
    },
  },
};
</script>

<style></style>
